import React from "react";
import MobileWrapper from '../../layouts/MobileWrapper';
import './style.css';
import { connect } from 'react-redux';
import {Card, WhiteSpace} from 'antd-mobile';
import applicationCenterService from '../../services/Employee/application-center-service';
import WorkReportTemplate from '../WorkReport/WorkReportTemplate';
import moment from "moment";
import dailyReportService from '../../services/WorkReport/daily-report-service';
import { Button,
  Modal,
  message,
  Input
 } from 'antd';

class MobileMyWeeklyReportDetail extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      data: props.fatherProps.location.state,
      ableReply: this.props.user.currentUser.PermissionDict.mobile_my_daily_report.reply_value
    }
  }

  componentWillMount() {
    this.getDetailData();
  }

  getDetailData(gets = {modelId: this.state.data.id}) {
    applicationCenterService.myMonthlyReportDetail(gets, res => {
      this.setState({
        monthlyReportTemplate: JSON.parse(res.data.work_report.table_content),
        real_name: res.data.employee.real_name,
        department_name: res.data.employee.department_name,
        position_name: res.data.employee.position_name,
        date_1:res.data.work_report.date_1,
        date_2:res.data.work_report.date_2,
        replies: res.data.replies,
      });
    }, err => {

    })

  }

  setCurrentComment = event => {
		this.setState({currentComment: event.target.value});
	}

  replyDailyReport  = callback => {
		let posts = {
			report_id: this.state.data.id,
			content: this.state.currentComment
		}
		if (posts.content) {
			dailyReportService.replyDailyReport(posts, res => this.replyDailyReportCallback(res, callback));
		}else{
			Modal.confirm({
				title: '您没有填写回复内容，确定要以空内容来回复么？',
				okText: '确认',
				cancelText: '取消',
				onOk: () => dailyReportService.replyDailyReport(posts, res => this.replyDailyReportCallback(res, callback)),
				onCancel: () => {}
			});
		}
  }
  
  replyDailyReportCallback = (res, callback) => {
		if (res.data.Success) {
      message.success("回复报告成功", 4);
			this.getDetailData()
			if ("function" === typeof callback) {
				callback();
			}else{
				this.closeCurrentModal();
			}
		}else{
			message.success("回复报告失败 " + res.data.Errors[0], 4);
		}
	}


  render() {

    return <div>
      <WhiteSpace size="lg"/>
        <Card full>
      <Card.Header title={"月工作报告"} extra={<span>Monthly Work Report</span>}/>
    <Card.Body>
      <div>姓名: {this.state.real_name} </div>
      <div>部门: {this.state.department_name} </div>
      <div>职位: {this.state.position_name} </div>
      <div>日期: {this.state.date_1} - {this.state.date_2} </div>
      </Card.Body>
      </Card>
      <WorkReportTemplate currentData={this.state.monthlyReportTemplate} openDetail={true}/>

    <div style={{textAlign:"left", lineHeight: "30px", margin: "15px 0px"}}>
      <p>报告回复列表 : </p>
        {this.state.replies && this.state.replies.map(reply => {
          return (<div key={reply.id}>
      <span style={{color: "blue"}}>{reply.real_name}</span>
        <span> ( </span>
        <span style={{color: "blue"}}>
        {reply.reply_time ? moment(reply.reply_time).format("YYYY-MM-DD HH:MM") : ""}
      </span>
        <span> ) </span>
        <span> 回复 : </span>
        <span>{reply.content}</span>
        </div>)
      })}
      { this.state.ableReply && 
        <div style={{margin:"15px 0px"}}>
        <div style={{textAlign:"left",marginBottom:"15px"}}>回复此报告 : </div>
        <Input.TextArea ref="reportReply" value={this.state.currentComment} placeholder="填写回复内容"
        onChange={this.setCurrentComment}></Input.TextArea>
        <Button type="primary" onClick={this.replyDailyReport.bind(this)}>
        <span>回复</span>
        </Button>
        </div>
      }
    </div>

    </div>

  }

}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}
const mapDispatchToProps = {
}
export default MobileWrapper(connect(mapStateToProps, mapDispatchToProps)(MobileMyWeeklyReportDetail));


// WEBPACK FOOTER //
// ./src/routes/Mobile/MobileMyMonthlyReportDetail.js